var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 73,
    viewBox: "0 0 63 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 0.0000038147,
    width: 73,
    height: 63,
    rx: 7,
    transform: "rotate(90 63 3.8147e-06)",
    fill: "#727272"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.328 35.1583C28.2838 35.1583 25.6478 34.0665 23.494 31.9124C21.3402 29.7586 20.2484 27.1233 20.2484 24.0788C20.2484 21.0354 21.3402 18.3997 23.4944 16.2452C25.6485 14.0918 28.2842 13 31.328 13C34.3725 13 37.0077 14.0918 39.1615 16.2456C41.3153 18.3994 42.4075 21.035 42.4075 24.0788C42.4075 27.1233 41.3153 29.759 39.1612 31.9127C37.007 34.0662 34.3714 35.1583 31.328 35.1583Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9417 48.3716C12.0038 47.4753 12.1295 46.4976 12.3144 45.4651C12.5011 44.4248 12.7415 43.4415 13.0293 42.5427C13.3266 41.6137 13.7308 40.6963 14.2306 39.8172C14.7493 38.9047 15.3586 38.1102 16.0422 37.4564C16.7571 36.7724 17.6324 36.2224 18.6445 35.8213C19.6531 35.4222 20.7709 35.2201 21.9666 35.2201C22.4362 35.2201 22.8903 35.4128 23.7673 35.9838C24.3071 36.3358 24.9385 36.7429 25.6432 37.1931C26.2457 37.5771 27.0621 37.9368 28.0703 38.2625C29.0541 38.5808 30.0529 38.7422 31.0387 38.7422C32.0245 38.7422 33.023 38.5808 34.0077 38.2625C35.015 37.9372 35.8313 37.5774 36.4331 37.1935C37.1312 36.7474 37.7629 36.3403 38.3107 35.9834C39.1867 35.4124 39.6412 35.2197 40.1108 35.2197C41.3068 35.2197 42.4242 35.4222 43.4325 35.8216C44.4439 36.2221 45.3196 36.772 46.0352 37.4567C46.7185 38.1109 47.3281 38.9051 47.8461 39.8172C48.3455 40.6963 48.7498 41.6134 49.0474 42.543C49.3348 43.4418 49.5752 44.4248 49.7619 45.4651C49.9469 46.4961 50.0725 47.4742 50.1346 48.3727C50.1957 49.2529 50.2266 50.1664 50.2266 51.089C50.2266 53.4902 49.4632 55.4342 47.958 56.8678C46.4714 58.2825 44.5043 59.0002 42.1122 59.0002H19.963C17.5709 59.0002 15.6046 58.2828 14.1176 56.8678C12.612 55.4352 11.8487 53.4909 11.8487 51.0887C11.849 50.1618 11.8803 49.2476 11.9417 48.3716Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9998,
    height: 46,
    fill: "white",
    transform: "matrix(-1 0 0 1 54 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.6015ead8865cf44dd515d6d78aefdad9.svg";
export { ForwardRef as ReactComponent };